import TemplateView from "../TemplateView";
import Switcher from './Switcher'

export default class SwitcherWithWrapper extends TemplateView {
    constructor({
        containerAdditionalClass = "",
        switcherWrapperAdditionalClass = "",
        switcherTextAdditionalClass = "",
        switcherAdditionalClass = "",
        onSwitchCallback = () => {},
        switcherText = "",

    }) {
        super(null)

        this.params = {
            containerAdditionalClass,
            switcherWrapperAdditionalClass,
            switcherTextAdditionalClass,
            switcherAdditionalClass,
            onSwitchCallback,
            switcherText,
        }

        this.state = {
            enabled: false,
        }

        this.onStatePropertyChanged('enabled', enabled => this.switcher.setState({enabled}))
    }

    templateHtml() {
        return '<div class="switcherContainer <%-containerAdditionalClass%>">' +
               '    <div class="switcherWrapper <%-switcherWrapperAdditionalClass%>"/>' +
               '    <div class="switcherText <%-switcherTextAdditionalClass%>"> <%-switcherText%> </div>' +
               '</div>'
    }

    templateModel() {
        return {
            containerAdditionalClass: this.params.containerAdditionalClass,
            switcherWrapperAdditionalClass: this.params.switcherWrapperAdditionalClass,
            switcherTextAdditionalClass: this.params.switcherTextAdditionalClass,
            switcherText: this.params.switcherText,
        }
    }

    afterRender() {
        this.switcher = new Switcher({
            additionalClass: this.params.switcherAdditionalClass,
            onSwitchCallback: enabled => {
                this.setStateInternal({enabled})
                this.params.onSwitchCallback(enabled)
            }
        }).init(this.find('.switcherWrapper'))
    }
}


// WEBPACK FOOTER //
// ./web/js/components/SwitcherWithWrapper.js